import * as React from 'react';
import { sanitizeToastHtml } from '@/ui/lib/sanitizeToastHtml';

// HTML を描画する唯一の場所。描画直前にサニタイズし、結果を加工しない
export function ToastMessage({ html }: { html: string }) {
  return <span dangerouslySetInnerHTML={{ __html: sanitizeToastHtml(html) }} />;
}
